import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import("@/components/dashboard/Dashboard.vue")
  },
  {
    path: '/ledger',
    name: 'LedgerView',
    component: () => import("@/components/TransactionListing.vue")
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import("@/components/Register.vue")
  },
  {
    path: '/balance-sheet',
    name: 'BalanceSheet',
    component: () => import("@/components/BalanceSheet.vue")
  },
  {
    path: '/config/account',
    name: 'Account',
    component: () => import("@/components/accounts/AccountTreeConfig.vue")
  },
  {
    path: '/config/counterparty',
    name: 'Counterparty',
    component: () => import("@/components/CounterpartyConfig.vue")
  },
  {
    path: '/config/transaction-type',
    name: 'Transaction type',
    component: () => import("@/components/TransactionTypeConfig.vue")
  },
  {
    path: '/config/currency',
    name: 'Currency',
    component: () => import("@/components/CurrencyConfig.vue")
  },
  {
    path: '/import',
    component: () => import("@/components/Import.vue")
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
